import { Action, createReducer, on } from '@ngrx/store';
import { StateLicensureState } from '../state/state-licensure.state';
import * as stateLicActions from 'src/app/compliance/store/actions/state-licensure.actions';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';

const initialState: StateLicensureState = {
    isEditMode: false,
    isAdminEditMode: false,
    details: null,
    attachments: [],
    projectTypes: [],
    uploadInProgress: LoadingTypes.LOADED,
    admins: [],
    error: undefined
};

const reducer = createReducer(
    initialState,
    on(stateLicActions.getStateDetails, (state, action) => ({
        ...state,
        stateId: action.stateId
    })),
    on(stateLicActions.getStateDetailsSuccess, (state, action) => ({
        ...state,
        details: action.details
    })),
    on(stateLicActions.toggleEditMode, (state, action) => ({
        ...state,
        isEditMode: action.isEditMode
    })),
    on(stateLicActions.toggleAdminEditMode, (state, action) => ({
        ...state,
        isAdminEditMode: action.isAdminEditMode
    })),
    on(stateLicActions.getStateDetailsAttachments, (state, action) => ({
        ...state,
        stateId: action.stateId
    })),
    on(stateLicActions.getStateDetailsAttachmentsSuccess, (state, action) => ({
        ...state,
        attachments: action.attachments
    })),
    on(stateLicActions.getProjectTypes, stateLicActions.getAdmins, (state, action) => ({
        ...state
    })),
    on(stateLicActions.getProjectTypesSuccess, (state, action) => ({
        ...state,
        projectTypes: action.projectTypes
    })),
    on(stateLicActions.getAdminsSuccess, (state, action) => ({
        ...state,
        admins: action.admins
    })),
    on(stateLicActions.uploadStateDetailsFile, (state, action) => ({
        ...state,
        file: action.file,
        uploadInProgress: LoadingTypes.LOADING
    })),
    on(stateLicActions.uploadStateDetailsFileSuccess, (state, action) => ({
        ...state,
        file: action.file,
        uploadInProgress: LoadingTypes.LOADED
    })),
    on(
        stateLicActions.getStateDetailsAttachmentsFailure,
        stateLicActions.getStateDetailsFailure,
        stateLicActions.getProjectTypesFailure,
        stateLicActions.uploadStateDetailsFileFailure,
        stateLicActions.getAdminsFailure,
        (state, action) => ({
            ...state,
            error: JSON.stringify(action.error)
        })
    )
);

export function stateLicensureReducer(state: StateLicensureState | undefined, action: Action) {
    return reducer(state, action);
}
